<style></style>
<template>
  <div class="creatCustomer-box">
    <div class="shade-box">
      <div class="shade-content">
        <p class="dialog-title-bg">客户状态管理
        <button type="button" aria-label="Close" class="el-dialog__headerbtn"   @click="resetUserForm()"><i class="el-icon-circle-close-outline"></i></button></p>
        <div class="el-dialog__body">
          <el-form :model="statusForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="用户名">
              <p>{{this.data.userName}}</p>
            </el-form-item>
            <el-form-item label="状态">
              <el-radio-group v-model="statusForm.userStatus">
                <el-radio :label="0">启用</el-radio>
                <el-radio :label="2">禁用</el-radio>
                <el-radio :label="1">删除</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="marginTop30">
              <el-button type="primary paddingTB7" @click="submitForm()" :disabled="disabled">确认</el-button>
              <el-button @click="resetUserForm()">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../server/api.js'
export default {
  props: {
    data:{
      type: Object
    },
  },
  name: "status",
  data(){
    return{
      disabled: false,
      statusForm: {
        userStatus: '',
      },
    };
  },
  created(){
    this.statusForm.userStatus = this.data.userStatus;
  },
  methods: {
    submitForm(){//修改状态
      this.disabled = true;
      let data = {
        "userName": this.data.userName,
        "userStatus": this.statusForm.userStatus
      }
      api.updateUser({data:data}).then(res =>{
        this.disabled = false;
        if(res.status == 'success'){
          this.$message.success(res.msg);
          this.resetUserForm();
        }
      })
    },
    resetUserForm(){//取消
      this.$emit('statusClose');
    }
  },
  components: {
    
  }
}
</script>
  




// WEBPACK FOOTER //
// src/components/customer/status.vue